// @flow

import prefersContrast from './prefersContrast';
import contrastPreferences, { type ContrastPreference } from './contrastPreferences';

export default prefersContrast;

export { contrastPreferences };
export type { ContrastPreference };
